export default [
  {
    id: 4,
    date: "2020 - 2022",
    title: "Master of Data science and decision support",
    text: `Faculty of science and technology of Marrakech`,
  },
  {
    id: 3,
    date: "2019 - 2020 ",
    title: "Bachelor's Degree in Distributed Computer Systems",
    text: `Faculty of science and technology of Marrakech`,
  },
  {
    id: 2,
    date: "2017 - 2019",
    title: "DEUST in Mathematics, Computer Science and Physics",
    text: `Faculty of science and technology of Marrakech`,
  },
  {
    id: 1,
    date: "2016 - 2017",
    title: "Bachelor of Science in Mathematics",
    text: `Sidi Ahmed Bennacer High School of Zagora`,
  },
  
]
